<template>
    <div class="e_handle_content e_note_content">
        <div class="topOperation">
            <div class="top-left">
                <ShowNavHead />
            </div>
        </div>
        <div class="main-con">
            <div class="crumbs">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>雇员</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/signupList?active=报名' }" v-if="type!='custEmp'">招聘管理</el-breadcrumb-item>
                    <el-breadcrumb-item>入职办理</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="e_handle_box">
                <p class="e_title">入职办理</p>
                <!-- <p class="f_title">入职信息</p> -->
                <div class="e_handle_form" v-loading="formLoading">
                    <el-form :inline="true" :rules="basicRules" ref="enterResumeForm" :model="basicQuery" class="e_form_box" label-width="115px">
                        <el-form-item label="身份证姓名:" prop="StrEmpName">
                            <el-input v-model="basicQuery.StrEmpName" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="身份证号:" prop="StrIdCard">
                            <el-input v-model="basicQuery.StrIdCard" @blur="getempdetail" size="small" clearable></el-input>
                            <p class="real_txt">
                                <span v-if="realQuery.idcard">真实身份证：{{realQuery.idcard}};</span>
                                <span v-if="realQuery.name">真实姓名：{{realQuery.name}}</span>
                            </p>
                        </el-form-item>
                        <el-form-item label="用工日期:" prop="DtEntryBdate">
                            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="basicQuery.DtEntryBdate" type="date" placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="联系方式:" prop="StrMobileEntry">
                            <div class="e_line01">
                                <el-input v-model="basicQuery.StrMobileEntry" size="small" clearable></el-input>
                                <!-- <span class="txt01">变更入职手机</span> -->
                            </div>
                        </el-form-item>
                        <el-form-item label="部门:" prop="StrDepName">
                            <el-input v-model="basicQuery.StrDepName" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="岗位:" prop="StrJobInf">
                            <el-input v-model="basicQuery.StrJobInf" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="政治面貌:" prop="StrPolitical">
                            <el-select v-model="basicQuery.StrPolitical" placeholder="" size="small">
                                <el-option v-for="item in politicsList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="身份证有效期:" prop="dtIcCareEdate">
                            <div class="r_flex">
                                <el-date-picker size="small" v-if="!isLongCheck" value-format="yyyy-MM-dd" v-model="basicQuery.dtIcCareEdate" :disabled="isLongCheck" type="date" placeholder="选择日期"></el-date-picker>
                                <el-checkbox v-model="isLongCheck" @change="longChange">长期有效</el-checkbox>
                            </div>
                        </el-form-item>
                        <el-form-item label="民族:" prop="StrNationClass">
                            <el-select v-model="basicQuery.StrNationClass" filterable placeholder="" size="small">
                                <el-option v-for="item in nationList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="籍贯:" prop="StrNativePlace">
                            <el-input v-model="basicQuery.StrNativePlace" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="户籍地址:" prop="StrNativeAddr">
                            <el-input v-model="basicQuery.StrNativeAddr" size="small" clearable></el-input>
                            <!-- <el-cascader :props="propsAddress" ref="cascaderArr" placeholder="" size="small" v-model="strCityCode" :options="provinces" @change="changeArea"></el-cascader> -->
                        </el-form-item>
                        <el-form-item label="现住地址:" prop="StrAddr">
                            <el-input v-model="basicQuery.StrAddr" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="参保种类:" prop="StrInsuranceType">
                            <el-input v-model="basicQuery.StrInsuranceType" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="参保日期:" prop="DtInsuranceDate">
                            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="basicQuery.DtInsuranceDate" type="date" placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="医保卡号:" prop="StrMedicalCard">
                            <el-input v-model="basicQuery.StrMedicalCard" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="合同协议类型:" prop="StrContractType">
                            <el-select v-model="basicQuery.StrContractType" placeholder="" size="small">
                                <el-option v-for="item in contractTypeList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="合同起始时间 :" prop="DtContractBtime">
                            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="basicQuery.DtContractBtime" type="date" placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="合同到期时间 :" prop="DtContractTime">
                            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="basicQuery.DtContractTime" type="date" placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="银行卡号:" prop="StrBankCard">
                            <el-input v-model="basicQuery.StrBankCard" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="银行:" prop="StrBankName">
                            <el-input v-model="basicQuery.StrBankName" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="计提:" prop="StrWithdrawal">
                            <el-input v-model="basicQuery.StrWithdrawal" size="small" clearable></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="招聘岗位类别:">
                            <el-select filterable v-model="basicQuery.StrInCity" placeholder="" size="small">
                            <el-option label="正式工" value="正式工"></el-option>
                            <el-option label="长期工" value="长期工"></el-option>
                            <el-option label="临时工" value="临时工"></el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item label="招聘岗位:" prop="posCategoryList">
                            <el-cascader ref="poSectionArr" size="small" placeholder="请选择招聘岗位" v-model="basicQuery.posCategoryList" :props="propPosition" filterable clearable :options="intendedPost" @change="poSectionChange"></el-cascader>
                        </el-form-item>
                        <el-form-item label="是否临时工:" prop="StrOther">
                            <el-select filterable v-model="basicQuery.StrOther" clearable placeholder="" size="small">
                                <el-option label="是" value="是"></el-option>
                                <el-option label="否" value="否"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="体检类型:">
                            <el-select filterable v-model="basicQuery.StrPetype" clearable placeholder="" size="small">
                                <el-option label="无要求" value="无要求"></el-option>
                                <el-option label="常规体检" value="常规体检"></el-option>
                                <el-option label="职业病体检" value="职业病体检"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="体检结果:">
                            <el-select filterable v-model="basicQuery.StrPeres" clearable placeholder="" size="small">
                                <el-option label="正常" value="正常"></el-option>
                                <el-option label="异常" value="异常"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="人员状态:">
                            <el-input v-model="basicQuery.StrEmpUsrStatus" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="工伤发生时间 :" prop="DtInjuryBdate">
                            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="basicQuery.DtInjuryBdate" type="date" placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="伤残等级:">
                            <el-select v-model="basicQuery.StrDisabilityLevel" size="small" placeholder="请选择伤残等级">
                                <el-option value="一级"></el-option>
                                <el-option value="二级"></el-option>
                                <el-option value="三级"></el-option>
                                <el-option value="四级"></el-option>
                                <el-option value="五级"></el-option>
                                <el-option value="六级"></el-option>
                                <el-option value="七级"></el-option>
                                <el-option value="八级"></el-option>
                                <el-option value="九级"></el-option>
                                <el-option value="十级"></el-option>
                                <el-option value="无等级"></el-option>
                                <el-option value="工亡"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="是否黑名单:">
                            <el-select filterable v-model="basicQuery.StrBlacklist" clearable placeholder="" size="small">
                                <el-option label="是" value="是"></el-option>
                                <el-option label="否" value="否"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="basicQuery.StrBlacklist=='是'" label="黑名单原因:" prop="StrBlacklistReason">
                            <el-select v-model="basicQuery.StrBlacklistReason" placeholder="" size="mini" clearable>
                                <el-option v-for="item in blackLabelList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="招聘渠道:" prop="qudao" class="e_half_line01">
                            <div class="e_line01">
                                <el-select v-model="basicQuery.qudao" placeholder="" size="small" style="width:200px;" @change="qudaoChange">
                                    <el-option value="社招">社招</el-option>
                                    <el-option value="公司渠道">公司渠道</el-option>
                                    <el-option value="外部渠道">外部渠道</el-option>
                                    <el-option value="企业转移">企业转移</el-option>
                                    <el-option value="内荐">内荐</el-option>
                                    <el-option value="独立招聘">独立招聘</el-option>
                                </el-select>
                                <!-- <el-cascader v-if="basicQuery.qudao == '社招'||basicQuery.qudao == '公司渠道'" placeholder="请选择部门"
                                v-model="dedpartNameList" ref="deSectionArr" :props="depprops" clearable filterable size="small"
                                :options="departList" style="margin:0 10px;width:500px;"
                                @change="handleDepSectionChange"></el-cascader> -->
                                <el-select filterable v-if="basicQuery.qudao == '社招'" v-model="szMember" clearable style="width:310px;margin-left:10px;" @change="faceSzMemberChange" placeholder="请选择人员" size="small">
                                    <el-option v-for="(item,index) in memberList" :key="index" :label="item.Username" :value="item.Username">
                                    </el-option>
                                </el-select>
                                <el-select filterable v-if="basicQuery.qudao == '公司渠道'" v-model="basicQuery.gsqdtjr" clearable style="width:310px;margin-left:10px;" placeholder="请选择人员" size="small" @change="faceMemberChange">
                                    <el-option v-for="(item,index) in memberList" :key="index" :label="item.Username" :value="item.Username">
                                    </el-option>
                                </el-select>
                                <div class="face_line_box" v-if="basicQuery.qudao == '内荐'">
                                    <span class="txts01">员工</span>
                                    <el-input placeholder="" v-model="njMember" style="width:250px;" size="small" clearable></el-input>
                                    <span class="txts02">推荐</span>
                                </div>
                                <el-input style="margin-left:10px;" v-if="basicQuery.qudao == '外部渠道'" placeholder="请输入渠道信息" v-model="basicQuery.wbqd" size="small" clearable></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item label="备注:" prop="StrRemark" class="f_all_width">
                            <el-input v-model="basicQuery.StrRemark" type="textarea" size="small" rows="1" clearable></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="合同到期提醒:" prop="Strother">
                            <el-radio-group v-model="radio">
                                <el-radio :label="3">提前7天</el-radio>
                                <el-radio :label="6">提前30天</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="身份证到期提醒:" prop="Strother">
                            <el-radio-group v-model="radio">
                                <el-radio :label="3">提前100天</el-radio>
                            </el-radio-group>
                        </el-form-item> -->
                    </el-form>
                </div>
                <!-- <div class="e_bottom_box">
                    <p>合并重复人员:</p>
                    <el-select v-model="basicQuery.StrEduLvl" placeholder="" size="small" >
                        <el-option v-for="item in eduList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                    </el-select>
                </div> -->
                <!-- 商保 -->
                <!-- <p class="f_title">商保</p>
                <el-form :model="insQuery" :inline="true" :rules="insRules" ref="insForm" label-width="130px">
                    <el-form-item label="险种名称" prop="InsuranceId">
                        <el-select v-model="insQuery.InsuranceId" placeholder="" size="small" clearable filterable @change="insChange">
                        <el-option v-for="(item,index) in planList" :key="index" :label="item.Bntype" :value="item.Id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="职业类别" prop="JobClasss">
                        <template #label>
                        <span>职业类别
                            <el-tooltip :content="JobClasssTip" placement="top" effect="light">
                            <div slot="content" class="JobClasssTip cp" @click="getTipDtl">
                            参考《职业分类表》
                            </div>
                            <i class="el-icon-question cp"></i>
                            </el-tooltip>
                        </span>
                        </template>
                        <el-select v-model="insQuery.JobClasss" placeholder="" clearable size="small">
                            <el-option v-for="(item,index) in JobClasssList" :key="index" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="员工属性" prop="EmployeeAttribute">
                        <el-select v-model="insQuery.EmployeeAttribute" placeholder="" clearable size="small">
                        <el-option value="长期工"></el-option>
                        <el-option value="临时工"></el-option>
                        <el-option value="日结工"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="岗位名称" prop="JobName">
                        <template #label>
                        <span>岗位
                            <el-tooltip placement="top" effect="light">
                            <div slot="content" class="JobClasssTip cp" @click="getTipDtl">
                                <div>需要具体细化，参考《职业分类表》进行填写</div>
                            </div>
                            <i class="el-icon-question cp"></i>
                            </el-tooltip>
                        </span>
                        </template>
                        <el-input v-model="insQuery.JobName" size="small" clearable></el-input>
                    </el-form-item>
                </el-form> -->
                <!-- 电子签 -->
                <!-- <p class="f_title">电子签签约</p>
                <el-form :model="signingForm" :inline="true" ref="signisForm" :rules="importRules" label-width="130px">
                    <el-form-item label="项目名称" prop="ObjName">
                        <el-select v-model="signingForm.ObjName" placeholder="" clearable filterable style="width:200px" @change="changePro" size="small">
                            <el-option v-for="item in proList" :key="item.Id" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="签约模板" prop="tempid">
                        <el-select v-model="tempNameSingle" placeholder="" clearable filterable style="width:200px" value-key="TempId" :disabled="!signingForm.ObjName" size="small" @change="changeTempSingle">
                            <el-option v-for="(item,index) in tempList" :key="index" :label="item.TempName" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="合同/协议类型" prop="ProtocolType">
                        <el-select v-model="signingForm.ProtocolType" value-key="name" placeholder="" clearable filterable size="small" @change="changeCont" style="width:200px">
                            <el-option v-for="(item,index) in contractList" :key="index" :label="item.name" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="合同预览" v-if="this.shangTempId">
                        <div style="width: 200px;">
                            <el-button type="text" class="blueName cp" @click="review">合同预览</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="员工签约主体" prop="ContractSubject">
                        <el-select v-model="signingForm.ContractSubject" placeholder="" clearable filterable style="width:200px" size="small" @change="(val)=>{changeLeg(val,'signingForm')}">
                            <el-option v-for="(item,index) in legList" :key="index" :value="item.enterpriseName"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="法人" prop="LegalPer" v-if="contractType!=11">
                        <el-input v-model="signingForm.LegalPer" readonly style="width:200px" disabled size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="注册地址" prop="RegisterAddress" v-if="contractType!=11">
                        <el-input v-model="signingForm.RegisterAddress" readonly style="width:200px" disabled size="small"></el-input>
                    </el-form-item>

                    <el-form-item :label="jobNameLabel" prop="list[0].JobName" v-if="contractType!=1 && contractType!=9 && contractType!=10 && contractType!=11 && contractType">
                        <el-input v-model="signingForm.list[0].JobName" style="width:200px" size="small"></el-input>
                    </el-form-item>

                    <el-form-item label="工作地点(区域)" prop="WorkSite" v-if="contractType==5 || contractType==6">
                        <el-input v-model="signingForm.WorkSite" style="width:200px" size="small"></el-input>
                    </el-form-item>

                    <el-form-item label="学校全称" prop="SchoolName" v-if="contractType==3 || contractType==9">
                        <el-input v-model="signingForm.SchoolName" style="width:200px" size="small"></el-input>
                    </el-form-item>

                    <el-form-item label="学生专业" prop="StudentMajor" v-if="contractType==9">
                        <el-input v-model="signingForm.StudentMajor" style="width:200px" size="small"></el-input>
                    </el-form-item>

                    <el-form-item label="入职日期" :prop="contractType==8 || contractType==9 || contractType==10?  '' : 'list[0].DtEntryBdate'" v-if="contractType!=11">
                        <el-date-picker type="date" placeholder="" v-model="signingForm.list[0].DtEntryBdate" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
                    </el-form-item>

                    <el-form-item label="文化程度" prop="list[0].StrEduLvl" v-if="contractType && contractType<8">
                        <el-input v-model="signingForm.list[0].StrEduLvl" style="width:200px" size="small"></el-input>
                    </el-form-item>

                    <el-form-item label="联系地址" prop="list[0].EmpContactAddress" v-if="contractType && contractType<8">
                        <el-input v-model="signingForm.list[0].EmpContactAddress" style="width:200px" size="small"></el-input>
                    </el-form-item>

                    <el-form-item label="客户单位全称" v-if="contractType==1 || contractType==3 || contractType==4">
                        <el-input v-model="signingForm.list[0].ClientFullName" style="width:200px" size="small"></el-input>
                    </el-form-item>

                    <el-form-item :label="contractType != 9 || contractType != 10 ? '合同起始时间' : '协议起始时间'" prop="ContractStartTime" v-if="contractType!=9 && contractType!=10 && contractType!=11 && contractType">
                        <el-date-picker type="date" placeholder="" v-model="signingForm.ContractStartTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
                    </el-form-item>
                    <el-form-item :label="contractType != 9 || contractType != 10 ? '合同时长（年）' : '协议时长（年）'" v-if="contractType!=9 && contractType!=10 && contractType!=11 && contractType">
                        <el-input type="number" v-model="ContractTime" @blur="getContractEndDate" style="width:200px" size="small" :disabled="!signingForm.ContractStartTime"></el-input>
                    </el-form-item>
                    <el-form-item :label="contractType != 9 || contractType != 10 ? '合同结束时间 （可编辑更改）' : '协议结束时间 （可编辑更改）'" prop="ContractEndTime" v-if="contractType!=9 && contractType!=10 && contractType!=11 && contractType">
                        <el-date-picker type="date" placeholder="" v-model="signingForm.ContractEndTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
                    </el-form-item>

                    <el-form-item label="试用期起始时间" prop="TrialPeriodStartTime" v-if="contractType == 1 ||contractType == 2 ||contractType == 5 ||contractType == 7">
                        <el-date-picker type="date" placeholder="" v-model="signingForm.TrialPeriodStartTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="试用期时长（月）" prop="TrialMonth" v-if="contractType == 1 ||contractType == 2 ||contractType == 5 ||contractType == 7">
                        <el-input type="number" v-model="signingForm.TrialMonth" style="width:200px" size="small" :disabled="!signingForm.TrialPeriodStartTime" @blur="getEndDate"></el-input>
                    </el-form-item>
                    <el-form-item label="试用期结束时间（可编辑更改）" prop="TrialPeriodEndTime" v-if="contractType == 1 ||contractType == 2 ||contractType == 5 ||contractType == 7">
                        <el-date-picker type="date" placeholder="" v-model="signingForm.TrialPeriodEndTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
                    </el-form-item>

                    <el-form-item :label="contractType==8 ? '终止（解除）劳动合同时间' : '终止（解除）协议时间'" prop="TimeLaborContract" v-if="contractType==8 || contractType==9 || contractType==10">
                        <el-date-picker type="date" placeholder="" v-model="signingForm.TimeLaborContract" value-format="yyyy-MM-dd" style="width:200px" size="small" @blur="changeTimeLaborContract"></el-date-picker>
                    </el-form-item>

                    <el-form-item label="工作时长(年)" prop="WorkingYear" v-if="contractType==8">
                        <el-input v-model="signingForm.WorkingYear" style="width:200px" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="工作时长(月)" prop="WorkingMonth" v-if="contractType==8">
                        <el-input v-model="signingForm.WorkingMonth" style="width:200px" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="工作时长(天)" prop="WorkingDay" v-if="contractType==8">
                        <el-input v-model="signingForm.WorkingDay" style="width:200px" size="small"></el-input>
                    </el-form-item>

                    <el-form-item :label="contractType==8 ? '终止（解除）劳动合同时间（员工联）' : '终止（解除）协议时间（员工联）'" prop="TimeLaborContractStaff" v-if="contractType==8 || contractType==9 || contractType==10">
                        <el-date-picker type="date" placeholder="" v-model="signingForm.TimeLaborContractStaff" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
                    </el-form-item>

                    <el-form-item label="银行卡号" v-if="contractType!=11">
                        <el-input v-model="signingForm.list[0].Bankcard" style="width:200px" size="small"></el-input>
                    </el-form-item>

                    <el-form-item label="开户银行" v-if="contractType!=11">
                        <el-input v-model="signingForm.list[0].DepositBank" style="width:200px" size="small"></el-input>
                    </el-form-item>

                    <el-form-item label="备注1" v-if="contractType==11">
                        <el-input v-model="signingForm.list[0].Remark1" style="width:200px" size="small"></el-input>
                    </el-form-item>

                    <el-form-item label="备注2" v-if="contractType==11">
                        <el-input v-model="signingForm.list[0].Remark2" style="width:200px" size="small"></el-input>
                    </el-form-item>

                    <el-form-item label="备注3" v-if="contractType==11">
                        <el-input v-model="signingForm.list[0].Remark3" style="width:200px" size="small"></el-input>
                    </el-form-item>
                </el-form> -->

                <div class="e_btns_box">
                    <el-button size="small" @click="backHandle">取消</el-button>
                    <el-button type="primary" :loading="btnLoading" @click="saveHandle" size="small">保存</el-button>
                </div>
            </div>
        </div>
        <!-- <div class="f_form_btn">
            <p class="r_edit_title">入职办理</p>
            <div class="r_title_btns">
                <el-button type="info" size="small" @click="isDetail = true">返回</el-button>
                <el-button v-if="editTxt == '编辑'" type="primary" size="small" @click="editHandle">编辑</el-button>
                <el-button v-if="editTxt == '保存编辑'" type="primary" @click="saveHandle('all')" size="small">保存编辑</el-button>
            </div>
        </div> -->

         <el-dialog title="合同预览" :visible.sync="showPreview" width="90%">
          <div v-loading="previewLoading" element-loading-text="加载中···" element-loading-spinner="el-icon-loading" v-if="previewLoading" style="height:500px"></div>
          <div v-if="previewLoading" style="height:500px"></div>
          <iframe style="width: 100%;height:80vh" :src="previewUrl"></iframe>
        </el-dialog>
    </div>
</template>

<script>
    import xz from "./../../common";
    import moment from 'moment'
    export default {
        data() {
            var validatetJobTips = (rule, value, callback) => {
                if (!this.signingForm.list[0].JobName) {
                    if (this.jobNameLabel == '工作岗位(A管理类、B技术类、C操作类)' || this.jobNameLabel == '工作岗位(A管理、B技术、C操作)') {
                        callback(new Error("请输入字母：A或B或C"));
                    } else {
                        callback(new Error("请输入工作岗位"));
                    }

                } else {
                    callback();
                }
            };
            var validatePhone = (rule, value, callback) => {
                const phoneReg = /^(10[0-9]|11[0-9]|12[0-9]|13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/i;
                // console.log('validatePhone',value)
                if (value.length == 11 && phoneReg.test(value)) {
                    //校验通过
                    callback()
                } else {
                    callback(new Error('请输入正确的手机号'))
                }
            }
            var validatecard = (rule, value, callback) => {
                if (value.length != 18) {
                    callback(new Error('身份证号码格式不正确'));
                } else {
                    let idcode = value;
                    let weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, ];
                    let check_code = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
                    let code = idcode + "";
                    let last = idcode[17].toUpperCase(); //最后一个
                    let seventeen = code.substring(0, 17);
                    // ISO 7064:1983.MOD 11-2
                    // 判断最后一位校验码是否正确
                    let arr = seventeen.split("");
                    let len = arr.length;
                    let num = 0;
                    for (let i = 0; i < len; i++) {
                        num = num + arr[i] * weight_factor[i];
                    }
                    // 获取余数
                    var resisue = num % 11;
                    var last_no = check_code[resisue];
                    // 格式的正则
                    // 正则思路
                    var idcard_patter = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
                    // 判断格式是否正确
                    var format = idcard_patter.test(idcode);
                    if (last === last_no && format == true) {
                        callback()
                    } else {
                        callback(new Error('身份证号码格式不正确'));
                    }
                }
            };
            return {
                btnLoading: false,
                formLoading: false,
                // 默认头像
                defaultPic: require(("./../../assets/images/psn.png")),
                // 简历来源
                originList: [],
                // 自定义 级联选择props
                propPosition: {
                    label: 'strParametername',
                    value: 'strParameterid',
                    children: 'children'
                },
                // 规则
                basicRules: {
                    StrEmpName: [{
                        required: true,
                        message: '请输入身份证姓名',
                        trigger: 'blur'
                    }],
                    StrIdCard: [{
                            required: true,
                            message: '请输入身份证号码',
                            trigger: 'blur'
                        },
                        {
                            message: '请输入正确的身份证号码',
                            validator: validatecard,
                            trigger: ['blur']
                        }
                    ],
                    StrMobileEntry: [{
                            required: true,
                            message: '请输入联系方式',
                            trigger: 'blur'
                        },
                        {
                            validator: validatePhone,
                            trigger: ['blur']
                        }
                    ],
                    DtEntryBdate: [{
                        required: true,
                        message: '请选择用工日期',
                        trigger: 'change'
                    }],
                    StrNationClass: [{
                        required: true,
                        message: '请选择民族',
                        trigger: 'change'
                    }],
                    qudao: [{
                        required: true,
                        message: '请选择招聘渠道',
                        trigger: 'change'
                    }],
                    // dtIcCareEdate: [
                    //     { required: true, message: '请选择身份证有效期', trigger: 'change' }
                    // ],
                    StrOther: [{
                        required: true,
                        message: '请选择是否临时工',
                        trigger: 'change'
                    }],
                    posCategoryList: [{
                        type: 'array',
                        required: true,
                        message: '请选择招聘岗位',
                        trigger: 'change'
                    }]
                },
                isDetail: true,
                // 选中的地区code
                strCityCode: '',
                // 意向岗位列表
                intendedPost: [],
                // 合同协议类型
                contractTypeList: [],
                // 社保需求列表
                socialList: ['需要', '不需要'],
                // 民族
                nationList: [],
                // 省份
                provinces: [],
                // 人员列表
                memberList: [],
                apartprops: {
                    label: 'strorganname',
                    value: 'strorgancode',
                    children: 'children',
                    checkStrictly: true
                },
                propsAddress: {
                    lazy: true,
                    checkStrictly: true,
                    value: 'Id',
                    label: 'Name',
                    lazyLoad(node, resolve) {
                        const {
                            value,
                            level
                        } = node;
                        if (value && value != undefined) {
                            xz.getArea(value).then(res => {
                                if (res.status == 'ok') {
                                    if (level === 2) {
                                        resolve(
                                            res.data.ret.map(item => {
                                                item.leaf = 'leaf'
                                                return item
                                            })
                                        )
                                    } else {
                                        resolve(res.data.ret)
                                    }
                                } else {
                                    this.$message.error('获取城市出错')
                                }
                            })
                        }
                    }
                },
                // 业务部门员工参数
                oneDepartQuery: {
                    strorgancode: '',
                    roletype: ''
                },
                // 部门员工参数
                departMemberQuery: {
                    currpage: 1,
                    perpage: 10000000,
                    keyword: "",
                    strWorkState: "在职",
                    strstation: "",
                    strorgancode: ""
                },
                // 入职参数
                basicQuery: {
                    posCategoryList: [],
                    dtIcCareEdate: '',
                    StrObjName: '', //项目名称
                    IntSerialNumber: '', //序号
                    StrTmpProject: '', //自定义项目1
                    StrDepName: '', //部门
                    StrJobInf: '', //岗位
                    StrEmpName: '', //姓名
                    StrIdCard: '', //身份证号码
                    StrPolitical: '', //政治面貌
                    DtIcCareEdate: '', //身份证有效终止时间
                    StrCityzenType: '', //户粮
                    StrPhoneNum: '', //联系方式
                    StrContName: '', //紧急联系人
                    StrContTel: '', //紧急联络方式
                    StrNationClass: '', //民族
                    StrNativePlace: '', //籍贯
                    StrNativeAddr: '', //户籍地址
                    StrAddr: '', //现住地址
                    StrEduLv: '', //教育程度
                    StrInsuranceType: '', //参保种类
                    DtInsuranceDate: '', //参保日期
                    StrMedicalCard: '', //医保卡号
                    DtEntryBdate: '', //用工之日
                    StrContractType: '', //合同（协议）类型
                    IntContractNum: '', //签定合同次数
                    StrContractBedate: '', //签订合同起止时间记录
                    DtProbationEdate: '', //试用期到期日期
                    DtContractBtime: '', //劳动合同起始时间
                    DtContractTime: '', //劳动合同到期时间
                    StrWorkState: '在职', //在/离职状态
                    StrBankCard: '', //银行卡号
                    StrBankName: '', //银行
                    StrWithdrawal: '', //计提
                    StrInCity: '', //招聘岗位类别
                    StrOutsideCity: '', //招聘岗位
                    StrOther: '否', //临时工
                    StrPetype: '', //体检类型
                    StrPeres: '', //体检结果
                    StrEmpUsrStatus: '', //人员状态
                    DtInjuryBdate: '', //工伤发生时间
                    StrDisabilityLevel: '', //伤残等级
                    DtInjuryEdate: '', //自定义项目5
                    StrBlacklist: '', //是否黑名单
                    StrBlacklistReason: '', //黑名单原因
                    StrRemark: '', //备注
                    qudao: '', //招聘渠道
                    sctjr: '', //社招推荐人(部门/人)
                    gsqd: '', //公司渠道
                    gsqdtjr: '', //公司渠道推荐人
                    wbqd: '', //外部渠道
                    wbqdtjr: '', //外部渠道推荐人
                    qtqk: '', //其他情况
                    StrMobileEntry: '', //真实入职手机号
                    StrExcelPath: '', //入职后的数据
                    IntExcelLine: 0 //入职后的数据
                },
                processQuery: {
                    Jobid: '', //岗位id
                    Projectid: '', //项目id
                    ResumeId: '', //简历ID
                    StrState: '入职', //当前状态
                    StrRemark: '', //否决原因 离职原因等
                    Dtviewtime: '', //面试时间
                    Strviewadd: '', //面试地址
                    Dtreachtime: '', //预计到岗时间
                    DtInducttime: '', //入职时间
                    StrIsphysical: '', //是否体检
                    Strphysicalhos: '', //体检医院
                    Dtquittime: '', //离职时间
                    Strquittype: '', //离职类型
                    StrIsBlack: '', //是否黑名单
                    StrBlacklabel: '', //黑名单标签
                    StrWorkAddress: '', //入职地址
                    Sctjr: '', //社招推荐人(部门/人)
                    Gsqd: '', //公司渠道
                    Gsqdtjr: '', //公司渠道推荐人
                    Wbqd: '', //外部渠道
                    Wbqdtjr: '', //外部渠道推荐人
                    Qtqk: '', //其他情况
                    StrIdCard: '', //身份证号码
                    StrMobileEntry: '', //真实入职手机号
                    StrExcelPath: '', //入职后的数据
                    IntExcelLine: 0 //入职后的数据
                },
                // 身份校验参数(二要素验证)
                idCheckQuery: {
                    strIdCard: '',
                    username: '',
                    banknum: '',
                    ProjectId: '',
                    ProjectName: ''
                },
                // 政治面貌
                politicsList: [],
                dtIcCareEdate: '',
                isLongCheck: false,
                // 部门参数
                departQuery: {
                    strorgancode: '',
                    roletype: ''
                },
                // 身份证校验参数
                idcardQuery: {
                    StrIdCard: '',
                    StrObjName: ''
                },
                // 服务部门列表
                departList: [],
                // 选中的部门
                dedpartNameList: [],
                // 选中的部门名称
                depNameVal: '',
                // 选中的社招推荐人
                szMember: '',
                njMember: '', //内荐人员
                // 黑名单列表
                blackLabelList: [],
                // 岗位名称
                CustomerJobName: '',
                // 真实姓名等信息
                realQuery: {
                    name: '',
                    idcard: ''
                },
                jobType: '',
                activeName: '',
                strBlacklabel: '', //黑名单标签
                recruitdep: '', //招聘部门
                depprops: {
                    label: 'strorganname',
                    value: 'strorgancode',
                    children: 'children',
                    checkStrictly: true
                },
                signingForm: {
                    ContractSubject: '', //主体
                    tempid: '',
                    ObjName: '', //项目名称
                    ContractSubject: '', //签约主体
                    LegalPer: '', //法人
                    RegisterAddress: '', //注册地址
                    ContractStartTime: '', //合同起始时间
                    ContractEndTime: '', //合同结束时间
                    TrialPeriodStartTime: '', //试用期起始时间
                    TrialPeriodEndTime: '', //试用期结束时间
                    TrialMonth: '', //试期月份
                    WorkSite: '', //工作地点
                    SchoolName: '', //学校
                    WorkingYear: '', //工作时长(年)
                    WorkingMonth: '', //工作时长(月)
                    WorkingDay: '', //工作时长(天)
                    TimeLaborContract: '', //终止（解除）劳动合同时间
                    TimeLaborContractStaff: '', //终止（解除）劳动合同时间（员工联）
                    list: [{
                        name: '',
                        PhoneNum: '',
                        StrIdCard: '',
                        DtEntryBdate: '', //入职日期
                        JobName: '', //岗位
                        StrEduLvl: '', //文化程度
                        EmpContactAddress: '', //联系地址
                        Bankcard: '', //银行卡号
                        DepositBank: '', //开户银行
                        Remark1: '',
                        Remark2: '',
                        Remark3: '',
                    }]
                },
                importRules: {
                    ObjName: {
                        required: true,
                        message: '请选择项目',
                        trigger: 'change'
                    },
                    tempid: {
                        required: true,
                        message: '请选择签约模板',
                        trigger: 'change'
                    },
                    ContractSubject: {
                        required: true,
                        message: '请选择主体',
                        trigger: 'change'
                    },
                    LegalPer: {
                        required: true,
                        message: '请选择法人',
                        trigger: 'change'
                    },
                    RegisterAddress: {
                        required: true,
                        message: '请选择注册地址',
                        trigger: 'change'
                    },
                    ProtocolType: {
                        required: true,
                        message: '请选择合同/协议类型',
                        trigger: 'change'
                    },
                    'list[0].DtEntryBdate': {
                        required: true,
                        message: '请选择入职日期',
                        trigger: 'change'
                    },
                    ContractStartTime: {
                        required: true,
                        message: '请选择合同起始时间',
                        trigger: 'change'
                    },
                    ContractEndTime: {
                        required: true,
                        message: '请选择合同结束时间',
                        trigger: 'change'
                    },
                    TrialPeriodStartTime: {
                        required: true,
                        message: '请选择试用期起始时间',
                        trigger: 'change'
                    },
                    TrialPeriodEndTime: {
                        required: true,
                        message: '请选择试用期结束时间',
                        trigger: 'change'
                    },
                    TrialMonth: {
                        required: true,
                        message: '请选择合同起始时间',
                        trigger: 'blur'
                    },
                    'list[0].name': {
                        required: true,
                        message: '请输入姓名',
                        trigger: 'blur'
                    },
                    'list[0].PhoneNum': {
                        required: true,
                        message: '请输入电话',
                        trigger: 'blur'
                    },
                    'list[0].StrIdCard': {
                        required: true,
                        message: '请输入身份证',
                        trigger: 'blur'
                    },
                    'list[0].JobName': {
                        required: true,
                        validator: validatetJobTips,
                        trigger: 'blur'
                    },
                    SchoolName: {
                        required: true,
                        message: '学校全称',
                        trigger: 'blur'
                    },
                    WorkSite: {
                        required: true,
                        message: '请输入工作地点(区域)',
                        trigger: 'blur'
                    },
                    WorkingYear: {
                        required: true,
                        message: '请输入工作时长(年)',
                        trigger: 'blur'
                    },
                    WorkingMonth: {
                        required: true,
                        message: '请输入工作时长(月)',
                        trigger: 'blur'
                    },
                    WorkingDay: {
                        required: true,
                        message: '请输入工作时长(天)',
                        trigger: 'blur'
                    },
                    TimeLaborContract: {
                        required: true,
                        message: '请选择终止（解除）劳动合同/协议时间',
                        trigger: 'change'
                    },
                    TimeLaborContractStaff: {
                        required: true,
                        message: '请选择终止（解除）劳动合同/协议时间（员工联）',
                        trigger: 'change'
                    },
                    StudentMajor: {
                        required: true,
                        message: '请输入学生专业',
                        trigger: 'blur'
                    },
                    'list[0].StrEduLvl': {
                        required: true,
                        message: '请输入文化程度',
                        trigger: 'blur'
                    },
                    'list[0].EmpContactAddress': {
                        required: true,
                        message: '请输入联系地址',
                        trigger: 'blur'
                    },
                },
                shangTempId: '', //合同ID
                legList: [], //主体列表
                previewUrl: '',
                showPreview: false, //合同预览弹窗
                currentPage: 1, // pdf当前页
                contractType: '',
                jobNameLabel: '',
                contractList: this.$store.state.EMP.contractList, //合同/协议列表
                ContractTime: '',
                tempList: [], //模板列表
                tempNameSingle: '',
                proList: [], //项目列表
                insQuery:{
                    BusinessType: 1,//1报增  报减
                    InsuranceId:'',//险种id
                    ProjectName:'',//项目名称
                    OrderNum:'',//订单号可不传
                    Projectid: '', //项目id
                    JobName: '', //岗位名称
                    JobClasss: '', //职业类别
                    EmployeeAttribute: '' //员工属性
                },
                insRules: {
                    InsuranceId: {
                        required: true,
                        message: "请选择险种",
                        trigger: "change"
                    },
                    JobClasss: {
                        required: true,
                        message: "请选择职业类别",
                        trigger: "change"
                    },
                    EmployeeAttribute: {
                        required: true,
                        message: "请选择员工属性",
                        trigger: "change"
                    },
                    JobName: {
                        required: true,
                        message: "请输入岗位名称",
                        trigger: "blur"
                    }
                },
                JobClasssList:[],
                planList: [], //险种列表
                JobNameTip: '需要具体细化，参考《职业分类表》进行填写',
                JobClasssTip: '参考《职业分类表》',
                previewLoading:false,
                roleType: localStorage.loginRoletype,
                // 是否通过二要素校验
                isPassIdCheck:false,
                type:''
            }
        },
        created() {
            console.log('yy',this.$route.params)
            this.type = this.$route.params.type;
            this.processQuery.Jobid = this.$route.params.Jobid
            this.CustomerJobName = this.$route.params.JobCategory
            this.processQuery.Projectid = this.$route.params.Projectid
            this.processQuery.ResumeId = this.$route.params.ResumeId
            this.processQuery.StrWorkAddress = this.$route.params.StrWorkAddress
            this.basicQuery.StrEmpName = this.$route.params.StrEmpName
            this.basicQuery.StrPhoneNum = this.$route.params.StrPhoneNum
            this.basicQuery.StrMobileEntry = this.$route.params.StrPhoneNum
            this.basicQuery.StrNationClass = this.$route.params.StrNationClass
            this.basicQuery.StrObjName = this.$route.params.StrObjName
            this.basicQuery.StrBlacklistReason = this.$route.params.StrBlacklabel
            this.basicQuery.StrJobInf = this.$route.params.jobName
            this.insQuery.Projectid = this.$route.params.Projectid
            this.insQuery.ProjectName = this.$route.params.StrObjName
            this.basicQuery.StrBlacklist = this.$route.params.StrIsBlack ? this.$route.params.StrIsBlack : '否';
            // if (!this.isNull(this.$route.params.StrBlacklabel)) {
            //     this.basicQuery.StrBlacklist = '是'
            //     console.log('1')
            // } else {
            //     this.basicQuery.StrBlacklist = '否'
            //      console.log('2')
            // }
            // this.departQuery.roletype = localStorage.loginRoletype
            // this.departQuery.strorgancode = localStorage.gancode
            this.basicQuery.StrIdCard = this.$route.params.StrIdCard
            this.basicQuery.qudao = this.$route.params.StrSource
            this.activeName = this.$route.params.activeName
            this.strBlacklabel = this.$route.params.StrBlacklabel
            this.recruitdep = this.$route.params.Recruitdep
            // console.log('jj',this.activeName)
            if (this.basicQuery.qudao == '社招') {
                this.szMember = this.$route.params.Recruitname
                // this.basicQuery.sctjr = this.depNameVal+'/'+this.szMember
            } else if (this.basicQuery.qudao == '公司渠道') {
                this.basicQuery.gsqdtjr = this.$route.params.Recruitname
            } else if (this.basicQuery.qudao == '内荐') {
                let firstIndex = this.$route.params.Recruitname.indexOf('工');
                let lastIndex = this.$route.params.Recruitname.lastIndexOf('推');
                let startindex = Number(firstIndex) + 1;
                this.njMember = this.$route.params.Recruitname.substring(startindex, lastIndex);
                this.basicQuery.qtqk = this.$route.params.Recruitname;
            } else if (this.basicQuery.qudao == '企业转移' || this.basicQuery.qudao == '独立招聘') {
                this.basicQuery.qtqk = this.basicQuery.qudao
            }
            // 是否临时工
            if (!this.isNull(this.$route.params.JobType) && this.$route.params.JobType.indexOf('临时工') > -1) {
                this.basicQuery.StrOther = '是'
            } else {
                this.basicQuery.StrOther = '否'
            }
            // 验证身份证
            this.getempdetail()
            this.getTreestr()
            // 民族
            this.getdictdatalistbyid('253')
            // 合同协议类型
            this.getdictdatalistbyid('174')
            // 政治面貌
            this.getdictdatalistbyid('160')
            // 黑名单标签
            this.getdictdatalistbyid('132')
            // 获取部门列表
            this.getDepartList()
            this.getMemberList()
            // this.getLegalSubjectList();
            this.getSearchJobProList();
            this.getInsurancManageByUserid()
        },
        methods: {
            // 保存
            saveHandle() {
                let that = this
                if (this.isLongCheck == false) {
                    this.basicQuery.DtIcCareEdate = this.basicQuery.dtIcCareEdate
                }
                if (this.basicQuery.qudao == '社招') {
                    // if(this.isNull(this.dedpartNameList)){
                    //     this.$message({ type: 'warning', message: '请选择社招部门' })
                    //     return false
                    // }
                    if (this.isNull(this.szMember)) {
                        this.$message({
                            type: 'warning',
                            message: '请选择社招人员'
                        })
                        return false
                    }
                    this.basicQuery.sctjr = this.depNameVal + '/' + this.szMember
                } else if (this.basicQuery.qudao == '公司渠道') {
                    // if(this.isNull(this.dedpartNameList)){
                    //     this.$message({ type: 'warning', message: '请选择公司渠道的部门' })
                    //     return false
                    // }
                    if (this.isNull(this.basicQuery.gsqdtjr)) {
                        this.$message({
                            type: 'warning',
                            message: '请选择公司渠道的人员'
                        })
                        return false
                    }
                } else if (this.basicQuery.qudao == '外部渠道') {
                    if (this.isNull(this.basicQuery.wbqd)) {
                        this.$message({
                            type: 'warning',
                            message: '请输入渠道信息'
                        })
                        return false
                    }
                } else if (this.basicQuery.qudao == '内荐') {
                    if (this.isNull(this.njMember)) {
                        this.$message({
                            type: 'warning',
                            message: '请输入员工名称'
                        })
                        return false
                    } else {
                        this.basicQuery.qtqk = '员工' + this.njMember + '推荐'
                    }
                } else if (this.basicQuery.qudao == '企业转移' || this.basicQuery.qudao == '独立招聘') {
                    this.basicQuery.qtqk = this.basicQuery.qudao
                }
                // console.log('保存', this.basicQuery)
                that.idCheckQuery.strIdCard = that.basicQuery.StrIdCard
                that.idCheckQuery.username = that.basicQuery.StrEmpName
                that.idCheckQuery.ProjectId = that.processQuery.Projectid
                that.idCheckQuery.ProjectName = that.basicQuery.StrObjName
                this.$refs['enterResumeForm'].validate((valid) => {
                    if (valid) {
                        // that.twoEleCheck()
                        // 二要素校验
                        xz.getcheckidcard(that.idCheckQuery).then(res => {
                            // console.log('ee', res)
                            if (res.status != 'ok') {
                                if(res.CardIDRet){
                                    that.basicQuery.StrIdCard = '';
                                }
                                if(res.RealName){
                                    that.basicQuery.StrEmpName = '';
                                }
                                if(that.isNull(res.CardIDRet)&&that.isNull(res.RealName)){
                                    that.basicQuery.StrEmpName = '';
                                }
                                that.realQuery.idcard = res.CardIDRet;
                                that.realQuery.name = res.RealName;
                                that.$message.error('身份证与姓名不匹配');
                            }else{
                                that.realQuery.idcard = '';
                                that.realQuery.name = '';
                                that.isPassIdCheck = true
                                that.btnLoading = true
                                if (that.activeName == '异常' || that.activeName == '离职') {
                                    let resNonList = []
                                    resNonList.push({
                                        Jobid: that.processQuery.Jobid, //岗位id
                                        Projectid: that.processQuery.Projectid, //项目id
                                        ResumeId: that.processQuery.ResumeId, //简历ID
                                        StrState: '终止', //当前状态
                                        StrRemark: '', //否决原因 离职原因等
                                        Dtviewtime: '', //面试时间
                                        Strviewadd: '', //面试地址
                                        Dtreachtime: '', //预计到岗时间
                                        DtInducttime: '', //入职时间
                                        StrIsphysical: '', //是否体检
                                        Strphysicalhos: '', //体检医院
                                        Dtquittime: '', //离职时间
                                        Strquittype: '', //离职类型
                                        StrMobileEntry: that.basicQuery.StrMobileEntry, //真实入职手机号
                                        StrExcelPath: '', //入职后的数据
                                        IntExcelLine: 0, //入职后的数据
                                        StrIsBlack: !that.isNull(that.basicQuery.StrBlacklistReason) ? '是' : '否', //是否黑名单
                                        StrBlacklabel: that.basicQuery.StrBlacklistReason, //黑名单标签
                                        StrIdCard: that.basicQuery.StrIdCard //身份证号码
                                    });
                                    // console.log('non',resNonList)
                                    // 终止旧流程
                                    xz.saveProcessRecords(resNonList).then(res => {
                                        if (res.status == 'ok') {
                                            // xz.inducEmpData(that.basicQuery).then(res => {
                                            //     // console.log('saveEnterHandle', res)
                                            //     if (res.status == 'ok') {
                                            that.processQuery.StrIsBlack = that.basicQuery.StrBlacklist
                                            that.processQuery.StrBlacklabel = that.basicQuery.StrBlacklistReason
                                            that.processQuery.DtInducttime = that.basicQuery.DtEntryBdate
                                            that.processQuery.StrIdCard = that.basicQuery.StrIdCard
                                            that.processQuery.Sctjr = that.basicQuery.sctjr //社招推荐人(部门/人)
                                            that.processQuery.Gsqd = that.basicQuery.gsqd //公司渠道
                                            that.processQuery.Gsqdtjr = that.basicQuery.gsqdtjr //公司渠道推荐人
                                            that.processQuery.Wbqd = that.basicQuery.wbqd //外部渠道
                                            that.processQuery.Wbqdtjr = that.basicQuery.wbqdtjr //外部渠道推荐人
                                            that.processQuery.Qtqk = that.basicQuery.qtqk //其他情况
                                            xz.broleInducEmpData(that.basicQuery).then(ele => {
                                                if (ele.status == 'ok') {
                                                    that.processQuery.StrMobileEntry = that.basicQuery.StrMobileEntry
                                                    that.basicQuery.StrExcelPath = ele.data.StrExcelPath //入职后的数据
                                                    that.basicQuery.IntExcelLine = ele.data.IntExcelLine
                                                    that.processQuery.StrExcelPath = ele.data.StrExcelPath //入职后的数据
                                                    that.processQuery.IntExcelLine = ele.data.IntExcelLine //入职后的数据
                                                    let arr = [that.processQuery]
                                                    that.changeProcessRecord(arr)
                                                } else {
                                                    this.$message({
                                                        type: 'error',
                                                        message: '操作失败，请稍后再试'
                                                    })
                                                }
                                            })
                                            //     }else{
                                            //         this.$message({ type: 'error', message: res.msg })
                                            //     }
                                            // })
                                        } else {
                                            this.$message({
                                                type: 'error',
                                                message: res.msg
                                            })
                                        }
                                    })
                                } else {
                                    // xz.inducEmpData(that.basicQuery).then(res => {
                                    //     // console.log('saveEnterHandle', res)
                                    //     if (res.status == 'ok') {
                                    that.processQuery.DtInducttime = that.basicQuery.DtEntryBdate
                                    that.processQuery.StrIdCard = that.basicQuery.StrIdCard
                                    that.processQuery.Sctjr = that.basicQuery.sctjr //社招推荐人(部门/人)
                                    that.processQuery.Gsqd = that.basicQuery.gsqd //公司渠道
                                    that.processQuery.Gsqdtjr = that.basicQuery.gsqdtjr //公司渠道推荐人
                                    that.processQuery.Wbqd = that.basicQuery.wbqd //外部渠道
                                    that.processQuery.Wbqdtjr = that.basicQuery.wbqdtjr //外部渠道推荐人
                                    that.processQuery.Qtqk = that.basicQuery.qtqk //其他情况
                                    xz.broleInducEmpData(that.basicQuery).then(ele => {
                                        if (ele.status == 'ok') {
                                            that.processQuery.StrMobileEntry = that.basicQuery.StrMobileEntry
                                            that.basicQuery.StrExcelPath = ele.data.StrExcelPath //入职后的数据
                                            that.basicQuery.IntExcelLine = ele.data.IntExcelLine
                                            that.processQuery.StrExcelPath = ele.data.StrExcelPath //入职后的数据
                                            that.processQuery.IntExcelLine = ele.data.IntExcelLine //入职后的数据
                                            let arr = [that.processQuery]
                                            that.changeProcessRecord(arr)
                                        } else {
                                            this.$message({
                                                type: 'error',
                                                message: '操作失败，请稍后再试'
                                            })
                                        }
                                    })
                                    //     }else{
                                    //         this.$message({ type: 'error', message: res.msg })
                                    //     }
                                    // })
                                }
                            }
                        })  
                    } else {
                        return false;
                    }
                })
            },
            // 二要素校验
            twoEleCheck(){
                let that = this
                that.idCheckQuery.strIdCard = that.basicQuery.StrIdCard
                that.idCheckQuery.username = that.basicQuery.StrEmpName
                that.idCheckQuery.ProjectId = that.processQuery.Projectid
                that.idCheckQuery.ProjectName = that.basicQuery.StrObjName
                if (!that.isNull(that.idCheckQuery.username)) {
                    // 二要素校验
                    xz.getcheckidcard(that.idCheckQuery).then(res => {
                        // console.log('ee', res)
                        if (res.status != 'ok') {
                            that.isPassIdCheck = false
                            if(res.CardIDRet){
                                that.basicQuery.StrIdCard = '';
                            }
                            if(res.RealName){
                                that.basicQuery.StrEmpName = '';
                            }
                            if(that.isNull(res.CardIDRet)&&that.isNull(res.RealName)){
                                that.basicQuery.StrEmpName = '';
                            }
                            that.realQuery.idcard = res.CardIDRet;
                            that.realQuery.name = res.RealName;
                            that.$message.error('身份证与姓名不匹配');
                        }else{
                            that.realQuery.idcard = '';
                            that.realQuery.name = '';
                            that.isPassIdCheck = true
                        }
                    })
                }
            },
            // 招聘渠道社招人员选择
            faceSzMemberChange(value) {
                let obj = {};
                let that = this
                if (!this.isNull(value)) {
                    obj = that.memberList.find((item) => {
                        return item.Username === value;
                    });
                    that.depNameVal = obj.Strorganname
                } else {
                    that.depNameVal = ''
                }
                // console.log('ff',obj)
            },
            // 招聘渠道公司渠道人员选择
            faceMemberChange(value) {
                let obj = {};
                let that = this
                if (!this.isNull(value)) {
                    obj = that.memberList.find((item) => {
                        return item.Username === value;
                    });
                    that.basicQuery.gsqd = obj.Strorganname
                } else {
                    that.basicQuery.gsqd = ''
                }
                // console.log('ff',obj)
            },
            // 根据级联选择器最后一级选中的值回显整个选中的数组-岗位
            getPath(treeData, targetName) {
                //  console.log(221, treeData, targetName);
                let path = [];
                let toggle = false;
                for (let i = 0; i < treeData.length; i++) {
                    let item = treeData[i];
                    path.push({
                        strParametername: item.strParametername,
                        strParameterid: item.strParameterid
                    });
                    if (item.strParametername == targetName) {
                        toggle = true;
                        break;
                    } else {
                        if (item.children) {
                            toggle = this.findPath(item.children, targetName, path, toggle);
                            if (!toggle) {
                                path.pop();
                            } else {
                                break;
                            }
                        } else {
                            path.pop();
                        }
                    }
                }
                if (toggle) {
                    // console.log(245, path);
                    return path;
                } else {
                    return [];
                }
            },
            findPath(nodes, targetName, path, toggle) {
                for (let i = 0; i < nodes.length; i++) {
                    let item = nodes[i];
                    path.push({
                        strParametername: item.strParametername,
                        strParameterid: item.strParameterid
                    });
                    if (item.strParametername === targetName) {
                        return true;
                    } else {
                        if (item.children) {
                            toggle = this.findPath(item.children, targetName, path, toggle);
                            if (toggle) {
                                return toggle;
                            } else {
                                path.pop();
                            }
                        } else {
                            path.pop();
                        }
                    }
                }
                return toggle;
            },
            // 招聘渠道选择
            qudaoChange() {
                this.njMember = ''
                this.basicQuery.wbqd = ''
                this.basicQuery.wbqdtjr = ''
                this.basicQuery.qtqk = ''
                this.basicQuery.gsqd = ''
                this.basicQuery.gsqdtjr = ''
                this.basicQuery.sctjr = ''
                this.szMember = ''
                this.depNameVal = ''
                this.dedpartNameList = []
            },
            // 服务部门选择
            // handleDepSectionChange(value){
            //     // console.log(value)
            //     if(this.isNull(value)){
            //         this.dedpartNameList = []
            //         this.basicQuery.gsqd = ''
            //         this.basicQuery.gsqdtjr = ''
            //         this.basicQuery.sctjr = ''
            //         this.szMember = ''
            //         this.depNameVal = ''
            //     }else{
            //         this.szMember = ''
            //         this.basicQuery.gsqdtjr = ''
            //         const checkedNode01 = this.$refs["deSectionArr"].panel.getNodeByValue(this.dedpartNameList);
            //         // console.log('checkedNode01',checkedNode01)
            //         let labels = checkedNode01.pathLabels;
            //         if(this.basicQuery.qudao == '社招'){
            //             this.depNameVal = labels[Number(labels.length)-1]
            //         }else{
            //             this.basicQuery.gsqd = labels[Number(labels.length)-1]
            //         }
            //         this.departQuery.strorgancode = value[Number(value.length)-1]
            //         // this.departQuery.roletype = localStorage.loginRoletype
            //         this.getMemberList()
            //     }
            // },
            // 获取部门列表
            getDepartList() {
                this.dedpartNameList = []
                xz.getorganstr('', '0383e791-72fd-4edc-aa70-2bcadminuser', {
                    strIsDisable: ''
                }).then(res => {
                    // console.log('部门', res)
                    if (res.status == 'ok') {
                        if (res.msg && res.msg.parent) {
                            this.departList = res.msg.parent[0].children
                            // 招聘部门回显
                            if (!this.isNull(this.recruitdep)) {
                                let posArrVal = this.getParentsById(
                                    this.departList,
                                    this.recruitdep
                                );
                                // console.log('posArrVal', posArrVal)
                                if (posArrVal.length > 1) {
                                    for (let index = 0; index < posArrVal.length; index++) {
                                        const posEle01 = posArrVal[index];
                                        this.dedpartNameList.push(posEle01.strorgancode)
                                    }
                                    this.dedpartNameList = this.dedpartNameList.reverse()
                                } else if (posArrVal.length == 1) {
                                    this.dedpartNameList = [posArrVal[0].strorgancode]
                                }
                                if (this.basicQuery.qudao == '社招') {
                                    this.depNameVal = this.recruitdep
                                } else {
                                    this.basicQuery.gsqd = this.recruitdep
                                }
                            }
                        }
                    } else {
                        this.departList = []
                    }
                });
            },
            // 添加流程记录
            changeProcessRecord(query) {
                let that = this
                this.signingForm.list[0].name = this.basicQuery.StrEmpName;
                this.signingForm.list[0].StrIdCard = this.basicQuery.StrIdCard;
                this.signingForm.list[0].PhoneNum = this.basicQuery.StrMobileEntry;
                xz.saveProcessRecords(query).then(res => {
                    // console.log('saveEnterHandle', res)
                    if (res.status == 'ok') {
                        that.$router.go(-1)
                        // that.submitESigning()
                        // that.saveInsureHandle()
                    } else {
                        that.$message({
                            type: 'error',
                            message: res.msg
                        })
                    }
                    that.btnLoading = false
                })
            },
            memberChange(val) {
                // console.log('val', val)
            },
            // 电子签保存
            submitESigning(){
                this.$refs["signisForm"].validate((valid) => {
                    if (valid) {
                        xz.submitESigningInfo(this.signingForm, this.roleType).then(res => {
                            if (res.status == 'ok') {
                                this.$message.error('发起电子签成功')
                            } else {
                                this.$message.error(res.msg)
                            }
                        })
                    }
                })
            },
            // 商保保存
            saveInsureHandle(){
                let that = this;
                let Insurance = {
                    BusinessType: that.insQuery.BusinessType,
                    InsuranceId: that.insQuery.InsuranceId,
                    ProjectName: that.insQuery.ProjectName,
                    Projectid: that.insQuery.Projectid
                }
                let userList = [{
                    MainlinsuredName: that.basicQuery.StrEmpName,
                    MainlinsuredCardId: that.basicQuery.StrIdCard,
                    Idtype: "身份证",
                    MainlinsuredPhone: that.basicQuery.StrPhoneNum,
                    JobName: that.insQuery.JobName,
                    JobClasss: that.insQuery.JobClasss,
                    EmployeeAttribute: that.insQuery.EmployeeAttribute
                }]
                let query = {
                    Insurance: Insurance,
                    userList: userList
                }
                // console.log('query',query)
                that.$refs["insForm"].validate((valid) => {
                    if (valid) {
                        xz.reportAddApprov(query, this.roleType).then(res => {
                            if (res.status == 'ok') {
                                this.$message.success('商保操作成功！');
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                    }
                })
            },
            // 选择险种
            insChange(val){
                if(!this.isNull(val)){
                    this.getInsurancCategory(val)
                }
            },
            //取自己可取到险种
            getInsurancManageByUserid() {
                let data = {
                pageNum: 1,
                pageSize: 10000
                }
                xz.getInsurancManageByUserid(data, this.roleType).then(res => {
                    if (res.status == 'ok') {
                        this.planList = res.data.list;
                    } else {
                        // this.$message("获取险种列表出错!");
                        this.planList = []
                    }
                })
            },
            //取职业类别
            getInsurancCategory(Id) {
                xz.getInsurancManage(Id, this.roleType).then(res => {
                    if (res.status == 'ok') {
                        this.JobClasssList = res.data.InsuranceManage.EmployeeAttribute.split(',');
                    } else {
                        // this.$message("获取险种列表出错!");
                        this.JobClasssList = []
                    }
                })
            },
            //查看资料详情
            getTipDtl() {
                let routeUrl = this.$router.resolve({
                path: "/model",
                });
                window.open(routeUrl.href, "_blank");
            },
            // 身份证校验
            getempdetail() {
                let that = this
                that.idCheckQuery.strIdCard = that.basicQuery.StrIdCard
                that.idCheckQuery.username = that.basicQuery.StrEmpName
                that.idCheckQuery.ProjectId = that.processQuery.Projectid
                that.idCheckQuery.ProjectName = that.basicQuery.StrObjName
                if (!this.isNull(this.basicQuery.StrIdCard)) {
                    this.idcardQuery.StrIdCard = this.basicQuery.StrIdCard
                    this.idcardQuery.StrObjName = this.basicQuery.StrObjName
                    // 验证身份证格式等是否正确
                    xz.checkidcardEmp(this.idcardQuery).then(res => {
                        // console.log('tt', res)
                        if (res.status != 'ok') {
                            let index = res.msg.indexOf(that.idcardQuery.StrObjName)
                            if (index > -1) {
                                that.basicQuery.StrIdCard = ''
                                that.$message.error(res.msg);
                                return
                            } else {
                                that.$confirm(res.msg + '，是否继续?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(() => {

                                }).catch(() => {
                                    // console.log('已取消')
                                    that.basicQuery.StrIdCard = ''
                                })
                            }
                        } else {
                            if (!that.isNull(that.idCheckQuery.username)) {
                                // 二要素校验
                                xz.getcheckidcard(that.idCheckQuery).then(res => {
                                    // console.log('ee', res)
                                    if (res.status != 'ok') {
                                        if(res.CardIDRet){
                                            that.basicQuery.StrIdCard = '';
                                        }
                                        if(res.RealName){
                                            that.basicQuery.StrEmpName = '';
                                        }
                                        if(that.isNull(res.CardIDRet)&&that.isNull(res.RealName)){
                                            that.basicQuery.StrEmpName = '';
                                        }
                                        that.realQuery.idcard = res.CardIDRet;
                                        that.realQuery.name = res.RealName;
                                        that.$message.error('身份证与姓名不匹配');
                                        return
                                    }else{
                                        that.realQuery.idcard = '';
                                        that.realQuery.name = '';
                                    }
                                })
                            } else {
                                this.$message({
                                    type: 'warning',
                                    message: '请输入姓名'
                                })
                                return false
                            }
                        }
                    })
                }
            },
            // 岗位类别选择
            poSectionChange(val) {
                // console.log('poSectionChange', val)
                // const checkedNode =  this.$refs['poSectionArr'].getCheckedNodes();
                const checkedNode = this.$refs["poSectionArr"].panel.getNodeByValue(this.basicQuery.posCategoryList);
                // console.log( checkedNode[0].data.strParametername ) ;  //获取当前点击节点的label值
                // console.log( checkedNode[0].pathLabels) ;  //获取由label组成的数组
                if (this.isNull(val)) {
                    this.basicQuery.StrInCity = ''
                    this.basicQuery.StrOutsideCity = ''
                    this.basicQuery.posCategoryList = []
                } else {
                    let labels = checkedNode.pathLabels;
                    this.basicQuery.posCategoryList = val
                    // console.log('poSectionChange', labels);
                    this.basicQuery.StrInCity = labels[0]
                    this.basicQuery.StrOutsideCity = labels[1];
                }
            },
            // 人岗匹配岗位 岗位类别
            getTreestr() {
                let data = {
                    currpage: 1,
                    perpage: 10000,
                    strIsDisable: '', // 传1 禁用的看不到了  不传就全显示
                    keyword: ''
                }
                // this.formLoading = true
                xz.getTreestr('JB_base_Jobcategory', data).then(res => {
                    if (res) {
                        this.intendedPost = res.msg.parent
                        // 招聘岗位回显
                        if (!this.isNull(this.CustomerJobName)) {
                            let posArrVal = this.getPath(
                                this.intendedPost,
                                this.CustomerJobName
                            );
                            // console.log('posArrVal', posArrVal)
                            if (posArrVal.length > 1) {
                                this.basicQuery.posCategoryList = [posArrVal[0].strParameterid, posArrVal[1].strParameterid]
                                this.basicQuery.StrInCity = posArrVal[0].strParametername
                                this.basicQuery.StrOutsideCity = posArrVal[1].strParametername
                            } else if (posArrVal.length == 1) {
                                this.basicQuery.posCategoryList = [posArrVal[0].strParameterid]
                                this.basicQuery.StrInCity = posArrVal[0].strParametername
                            }
                        }
                    } else {
                        this.intendedPost = []
                    }
                    // this.formLoading = false
                })
            },
            // 获取员工列表
            getMemberList() {
                xz.getauthUserInfoByorgancode(this.departMemberQuery).then(res => {
                    // console.log('员工', res)
                    if (res.status == 'ok') {
                        this.memberList = res.msg
                    } else {
                        this.memberList = []
                    }
                })
            },
            //参数列表（班次、坐班站班）
            getdictdatalistbyid(id) {
                xz.getdictdatalistbyid(id).then(res => {
                    // console.log('getdictdatalistbyid', res)
                    if (res.status == 'ok') {
                        if (id == '253') {
                            // 民族
                            this.nationList = res.data.retList
                        }
                        if (id == '132') { // 黑名单标签
                            this.blackLabelList = res.data.retList
                        }
                        if (id == '174') {
                            // 合同协议类型
                            this.contractTypeList = res.data.retList
                        }
                        if (id == '160') {
                            // 政治面貌
                            this.politicsList = res.data.retList
                        }
                    }
                })
            },
            // 修改长期有效
            longChange(val) {
                // console.log('val',val)
                if (val == true) {
                    this.basicQuery.dtIcCareEdate = moment(new Date()).format('YYYY-MM-DD')
                    this.basicQuery.DtIcCareEdate = '2999-12-31'
                }
            },
            // 返回
            backHandle() {
                this.$router.back()
                // this.$router.go(-1) // 后退+刷新
            },
            //获取省份
            getprovinces(parent) {
                xz.getArea(parent).then(res => {
                    // console.log('getprovinces', res)
                    if (res.status == 'ok') {
                        this.provinces = res.data.ret;
                    } else {
                        this.provinces = [];
                    }
                })
            },
            //判断是否为空(包含0)
            isNull(o) {
                return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
            },
            //根据targetName查询该节点和所有父级节点 回显el-cascader组件的值
            getParentsById(list, targetName) {
                for (let i in list) {
                    if (list[i].strorganname === targetName) {
                        //查询到就返回该数组对象
                        return [list[i]]
                    }
                    if (list[i].children) {
                        let node = this.getParentsById(list[i].children, targetName)
                        if (node !== undefined) {
                            //查询到把父节点连起来
                            return node.concat(list[i])
                        }
                    }
                }
            },

            //单笔签约选择模板
            changeTempSingle(val) {
                this.tempNameSingle = val.TempName;
                this.signingForm.tempid = val.TempId;
                this.shangTempId = val.shangTempId;
            },

            //选择主体
            changeLeg(val, list) {
                if (val) {
                    xz.getLegalSubjec(val).then(res => {
                        if (res.status == 'ok') {
                            this.$set(this[list], 'LegalPer', res.data.LegalPerson)
                            this.$set(this[list], 'RegisterAddress', res.data.RegisteredAddress.indexOf('$$') > -1 ? res.data.RegisteredAddress.replace('$$', '') : res.data.RegisteredAddress)
                        } else {
                            this.$message.error('获取主体信息出错')
                        }
                    })
                } else {
                    this.$set(this[list], 'LegalPer', '')
                    this.$set(this[list], 'RegisterAddress', '')
                }
            },
            //取签约主体列表
            getLegalSubjectList() {
                xz.getLegalSubjectList('', this.roletype).then(res => {
                    if (res.status == 'ok') {
                        this.legList = res.data
                    } else {
                        this.$message.error('获取签约主体列表出错');
                    }
                })
            },
            review() {
                xz.getTempCombined(this.shangTempId, this.roletype).then(res => {
                    if (res.status == 'ok') {
                        let url = res.data.content;
                        let base64 = url.toString()
                        let byteCharacters = atob(
                            base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
                        )
                        let byteNumbers = new Array(byteCharacters.length)
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i)
                        }
                        let byteArray = new Uint8Array(byteNumbers)
                        let blob = new Blob([byteArray], {
                            type: `application/pdf`
                        })
                        this.currentPage = 1;
                        this.previewUrl = URL.createObjectURL(blob);
                        this.showPreview = true;
                    } else {
                        this.$message.error('获取合同失败')
                    }
                })
            },
            //选择主体
            changeLeg(val, list) {
                if (val) {
                    xz.getLegalSubjec(val).then(res => {
                        if (res.status == 'ok') {
                            this.$set(this[list], 'LegalPer', res.data.LegalPerson)
                            this.$set(this[list], 'RegisterAddress', res.data.RegisteredAddress.indexOf('$$') > -1 ? res.data.RegisteredAddress.replace('$$', '') : res.data.RegisteredAddress)
                        } else {
                            this.$message.error('获取主体信息出错')
                        }
                    })
                } else {
                    this.$set(this[list], 'LegalPer', '')
                    this.$set(this[list], 'RegisterAddress', '')
                }
            },
            //选择合同/协议
            changeCont(val) {
                // this.$refs.signingForm.validate();
                this.signingForm.ProtocolType = val.name;
                this.contractType = val.val;
                this.jobNameLabel = val.jobNameLabel;
            },
            getEndDate() {
                if (this.signingForm.TrialMonth > 0) {
                    this.signingForm.TrialPeriodEndTime = moment(this.signingForm.TrialPeriodStartTime).add(this.signingForm.TrialMonth, 'months').format('YYYY-MM-DD');
                    this.signingForm.TrialPeriodEndTime = moment(this.signingForm.TrialPeriodEndTime).subtract(1, 'days').format('YYYY-MM-DD');
                } else {
                    this.signingForm.TrialPeriodEndTime = this.signingForm.TrialPeriodStartTime
                }
            },
            getContractEndDate() {
                if (this.ContractTime >= 1) {
                    this.signingForm.ContractEndTime = moment(this.signingForm.ContractStartTime).add(this.ContractTime, 'years').format('YYYY-MM-DD');
                    this.signingForm.ContractEndTime = moment(this.signingForm.ContractEndTime).subtract(1, 'days').format('YYYY-MM-DD');
                }
            },
            // 获取到pdf总页数时触发 会传入总页数
            getTotalPage(page) {
                this.pageTotal = page
            },
            chengPage(type) {
                // 防抖 0.5秒内不再次触发时执行
                if (this.pageChangeTimer) {
                    clearTimeout(this.pageChangeTimer)
                }
                // 执行翻页
                this.pageChangeTimer = setTimeout(() => {
                    if (type === '+') {
                        this.currentPage += 1
                    } else {
                        this.currentPage -= 1
                    }
                    // 翻页后将滚动条归位到顶部
                    // this.scrollbarReset()
                    this.pageChangeTimer = null
                }, 500)
            },
            // 方法 滚动条归位到顶部
            scrollbarReset() {
                let boxDom = document.querySelector('.preview_box')
                boxDom.scrollTop = 0
            },
            disabledDate(time) {
                return (time.getTime() < new Date(this.mon1).getTime() || time.getTime() > new Date().getTime())
            },
            changeEmpSigningStartTime() {
                this.listQuery.EmpSigninEndTime = this.listQuery.EmpSigningStartTime
            },
            changeApprovalStartTime() {
                this.listQuery.ApprovalEndTTime = this.listQuery.ApprovalStartTime
            },
            //计算工作时长
            changeTimeLaborContract(val) {
                let m1 = this.signingForm.ContractStartTime + ' 00:00:00';
                let m2 = this.signingForm.TimeLaborContract + ' 00:00:00';
                let diff = moment.preciseDiff(m1, m2, true);
                console.log(diff)
                this.signingForm.WorkingYear = diff.years;
                this.signingForm.WorkingMonth = diff.months;
                this.signingForm.WorkingDay = diff.days + 1;
            },
            changePro(val) {
                this.signingForm.tempid = ''
                if (val) {
                    xz.templatesByProjectList(val, this.roleType).then(res => {
                        if (res.status == 'ok') {
                            this.tempList = res.data.tempList;
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
                }
            },
            // 获取项目列表
            getSearchJobProList() {
                let proNameQuery = {
                    roletype: localStorage.loginRoletype,
                    projectname: "",
                    perpage: 10000,
                    currpage: 1,
                };
                let that = this
                xz.getProjectLists(proNameQuery).then((res) => {
                    if (res.status == "ok") {
                        this.proList = res.msg;
                        if (!that.isNull(that.$route.params.Projectid)) {
                            let obj = {};
                            let id = that.$route.params.Projectid;
                            obj = that.proList.find((item) => {
                                return item.Projectid === id;
                            });
                            // console.log('hh',val)
                            that.signingForm.ObjName = obj.StrprojectName
                            // that.changePro(this.signingForm.ObjName)
                        }
                    } else {
                        this.proList = [];
                    }
                });
            },
        }
    }
</script>

<style>
    .e_handle_content .e_handle_box .el-form-item__label {
        vertical-align: top;
    }

    .e_handle_content .el-form--inline .el-form-item__content {
        vertical-align: middle;
    }

    .e_handle_content .el-form-item__content {
        width: 205px;
    }

    .e_handle_content .e_half_line01 .el-form-item__content {
        width: 535px;
    }

    .e_handle_content .f_all_width01 .el-form-item__content {
        width: calc(100% - 135px);
    }

    .f_all_width .el-form-item__content {
        width: calc(100% - 135px);
    }

    .e_handle_content .el-form-item {
        margin-bottom: 16px;
        margin-right: 0;
    }

    .e_handle_content .el-input--small .el-input__icon {
        height: 32px;
    }
    .e_note_content .el-form-item__label:before{
        font-size: 16px;
        font-weight: 800;
        color:red!important;
        margin-right: 0!important;
    }
</style>
<style scoped>
.f_title{
    margin: 0;
    font-size: 14px;
    line-height: 30px;
    padding-left: 20px;
    color: #333;
    /* font-weight: 550; */
    margin-bottom: 10px;
    border-bottom: 1px dashed #ddd;
}
    .real_txt {
        margin: 0;
        font-size: 13px;
        line-height: 20px;
        color: #F56C6C;
    }

    .real_txt span {
        margin-top: 5px;
    }

    .face_line_box {
        display: flex;
        flex-wrap: wrap;
        font-size: 14px;
        margin-left: 10px;
    }

    .face_line_box .txts01 {
        margin-right: 3px;
    }

    .face_line_box .txts02 {
        margin-left: 3px;
    }

    .r_flex {
        display: flex;
        align-items: center;
    }

    .e_bottom_box {
        width: 100%;
        box-sizing: border-box;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .e_bottom_box p {
        margin-right: 10px;
    }

    .e_handle_form {
        width: 100%;
        margin: 0 auto;
        flex-wrap: wrap;
    }

    .e_half_line {
        width: 549px;
    }

    .e_half_line01 {
        width: 652px;
    }

    .e_handle_content .el-input,
    .e_handle_content .el-cascader,
    .e_handle_content .el-select {
        width: 200px;
    }

    .e_form_box {
        margin-top: 10px;
    }

    .e_btns_box {
        display: flex;
        justify-content: center;
        padding: 10px 0;
    }

    .f_all_width {
        width: 100%;
        align-items: center;
    }

    .e_line01 {
        display: flex;
        align-items: center;
    }

    .e_handle_box .txt01 {
        font-size: 13px;
        color: #19bd92;
        cursor: pointer;
        margin-left: 5px;
    }

    .e_handle_form {
        display: flex;
        /* text-align: center; */
    }

    .e_handle_box {
        width: 100%;
        padding: 10px 0;
        background-color: #fff;
        box-sizing: border-box;
    }

    .e_handle_content .e_handle_box .el-form-item__label {
        padding: 0 5px 0 0;
        vertical-align: top;
    }

    .e_title {
        width: 100%;
        text-align: center;
        line-height: 25px;
        font-size: 16px;
        color: #333333;
    }
</style>